import {
  IdentificationIcon,
  BuildingLibraryIcon,
  EnvelopeIcon,
  PhoneIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import React from "react";
import { Link } from "react-router-dom";
import { ClipboardContext } from "../../common/context/clipboard";
import { AgentQuery, Application } from "../../graphql/generated";
import AgentItemActions from "./itemactions";
import AgentPic from "./pic";
import PageHeader from "../../common/components/page-header";
import { ApplicationIcon } from "../../common/components/application";

const AgentTitle: React.FC<{ agent?: AgentQuery["agent"] }> = ({ agent }) => {
  const { sendToClip } = React.useContext(ClipboardContext);

  const isRealtorPlus = agent?.mls?.application === Application.RealtorPlus;
  const displayName = (isRealtorPlus && agent?.rdcName) || agent?.name;
  const displayEmail = (isRealtorPlus && agent?.rdcEmail) || agent?.email;
  const displayPhone = (isRealtorPlus && agent?.rdcPhone) || agent?.phone;
  const nameOverridden = isRealtorPlus && agent?.rdcName && agent.rdcName !== agent.name;
  const emailOverridden = isRealtorPlus && agent?.rdcEmail && agent.rdcEmail !== agent.email;
  const phoneOverridden = isRealtorPlus && agent?.rdcPhone && agent.rdcPhone !== agent.phone;

  return (
    <PageHeader>
      <PageHeader.Pic>
        <AgentPic agent={agent} large />
      </PageHeader.Pic>
      <PageHeader.Title>
        {displayName?.trim() === "" ? "Empty Name" : displayName}
        {nameOverridden && (
          <span className="ml-2 text-sm text-gray-400 line-through">{agent?.name}</span>
        )}
      </PageHeader.Title>
      <PageHeader.Details>
        <PageHeader.DetailsItem icon={IdentificationIcon}>
          {agent?.mlsId}
        </PageHeader.DetailsItem>
        <PageHeader.DetailsItem icon={BuildingLibraryIcon}>
          <ApplicationIcon application={agent?.mls?.application} />{" "}{agent?.mls?.name}
        </PageHeader.DetailsItem>
      </PageHeader.Details>
      <PageHeader.Details>
        <PageHeader.DetailsItem icon={EnvelopeIcon}>
          <div
            className="text-blue-900 cursor-pointer"
            onClick={() => sendToClip(displayEmail!)}
          >
            {displayEmail}
          </div>
          {emailOverridden && (
            <span className="ml-1 text-xs text-gray-400 line-through">{agent?.email}</span>
          )}
          <Link
            to={{
              pathname: "/subetha/recipients",
              search: `?email=${displayEmail}`,
            }}
          >
            <MagnifyingGlassIcon
              className="flex-shrink-0 mx-1.5 h-5 w-5 text-zenlist-400"
              aria-hidden="true"
            />
          </Link>
        </PageHeader.DetailsItem>
        {displayPhone && (
          <PageHeader.DetailsItem icon={PhoneIcon}>
            <a href={`tel:${displayPhone}`}>{displayPhone}</a>
            {phoneOverridden && (
              <span className="ml-1 text-xs text-gray-400 line-through">{agent?.phone}</span>
            )}
          </PageHeader.DetailsItem>
        )}
      </PageHeader.Details>
      <PageHeader.Actions>
        <AgentItemActions agent={agent} />
      </PageHeader.Actions>
    </PageHeader>
  );
};

export default AgentTitle;
